import { FunctionComponent } from 'react'

import Icon from 'components/shared/Icon'

const Offline: FunctionComponent = ({ title = 'Not available offline' }: OfflineProps) => (
  <div className='pv12 lite-grey flex flex-column items-center f3'>
    <span className='w7'><Icon name='icon-wifi' /></span>
    <span className='mt6'>
      {title}
    </span>
  </div>
)

interface OfflineProps {
  title: string
}

export default Offline
